<template>
  <div class="icon-gallery">
    <h1>Icon Library</h1>
    <div class="grid">
      <div
        v-for="iconName in iconNames"
        :key="iconName"
        class="icon-card"
        @click="copyToClipboard(iconName)"
      >
        <ZSIcon :icon="iconName" size="large" />
        <span class="icon-name">{{ iconName }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { icons } from './global/icons/index.js';
import ZSIcon from './global/ZSIcon.vue';
import { useZSToast } from '@/components/zs-components/toast/useToast';

const iconNames = ref([]);
const toast = useZSToast();

onMounted(() => {
  iconNames.value = Object.keys(icons);
});

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text)
    .then(() => {
      toast.add({
        type: 'success',
        summary: 'Copied',
        detail: `'${text}' copied to clipboard!`,
        life: 3000,
      });
    })
    .catch((err) => {
      toast.add({
        type: 'error',
        summary: 'Error',
        detail: 'Failed to copy to clipboard.',
        life: 3000,
      });
      console.error('Failed to copy: ', err);
    });
};
</script>

<style scoped>
.icon-gallery {
  padding: 2rem;
  font-family: sans-serif;
}

h1 {
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 1.5rem;
}

.icon-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.icon-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.icon-name {
  margin-top: 0.75rem;
  font-size: 0.875rem;
  color: #555;
  text-align: center;
  word-break: break-all;
}
</style>
